export const GENERIC_EXPORT_GET_EXPORTFILETYPE =
  'GENERIC_EXPORT_GET_EXPORTFILETYPE';
export const GENERIC_EXPORT_SET_LOADING = 'GENERIC_EXPORT_SET_LOADING';
export const GENERIC_EXPORT_SET_SUBMITTING = 'GENERIC_EXPORT_SET_SUBMITTING';
export const GENERIC_EXPORT_GET_FILE = 'GENERIC_EXPORT_GET_FILE';
export const GENERIC_EXPORT_ERROR = 'GENERIC_EXPORT_ERROR';
export const GENERIC_EXPORT_CLEAR_ERROR = 'GENERIC_EXPORT_CLEAR_ERROR';



// WEBPACK FOOTER //
// ./src/pages/genericexport/state/monthlyexport/types.js